import dayjs from "dayjs";
import CalendarEventItem from "../CalendarEventItem";
// import locale from 'dayjs/locale/pl';
export default {
  components: {
    CalendarEventItem
  },
  props: {
    selectedDate: {
      type: Object,
      default: () => ({})
    },
    day: {
      type: Object,
      default: () => ({})
    },
    isToday: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    colorsForRecords: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    dayNumber() {
      return dayjs(this.day.date).date();
    }
  },
  methods: {
    goToClickedMonth() {
      let newSelectedDate = {};
      if (this.day.isNextMonth) {
        newSelectedDate = dayjs(this.selectedDate).add(1, "month");
      } else if (this.day.isPreviousMonth) {
        newSelectedDate = dayjs(this.selectedDate).subtract(1, "month");
      } else {
        return;
      }
      this.$emit("setNewDate", newSelectedDate);
    },
    openSelectedDayCalendar() {
      this.$emit("openDayCalendar", this.day.date);
    }
  }
};
